import { Component, inject, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'mmu-widget-configuration-dialog',
  templateUrl: './mmu-widget-configuration-dialog.component.html'
})
export class MmuWidgetConfigurationDialog<C = unknown> implements OnInit {

  /**
   * This template has to be set by the widget that needs to be configured. It is displayed within the dialog and serves the
   * purpose of entering the configuration data. It is passed the config object both as $implicit and config template variable.
   */
  content!: TemplateRef<unknown>;

  /** This FormGroup will be used to validate the user input and the form value is sent and saved as the new configuration. */
  form: FormGroup = new UntypedFormGroup({});

  /** This is the widget name that is displayed in the modal header */
  widgetName = '';

  private modal = inject(NgbActiveModal);

  ngOnInit(): void {
    if (!this.content) {
      throw new Error('MmuWidgetConfigurationDialog: The content property has to be set for this dialog to work!');
    }
  }

  /** Closes the modal and resolves the modal result with the config object. */
  save(config: C): void {
    this.modal.close(config);
  }

  /** Dismisses the modal and rejects the modal result promise. */
  dismiss(): void {
    this.modal.dismiss();
  }

}
